import script from "./DocumentUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentUpload.vue?vue&type=script&setup=true&lang=js"

import "./DocumentUpload.vue?vue&type=style&index=0&id=67793aff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67793aff"]])

export default __exports__